import React, { useState, useEffect, useRef } from "react";
import classes from "./PromotionData.module.css";
import Navbar from "../Components/Navbar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { misData } from "../Services/Apis";
import axios from "axios";
import { Calendar } from "primereact/calendar";

const PromotionData = () => {
  const [count, setCount] = useState("0");
  const [date, setDate] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [data, setData] = useState([]);

  console.log(data);

  // Ref for PrimeReact Calendar
const countCalendarRef = useRef(null);
const startCalendarRef = useRef(null);
const endCalendarRef = useRef(null);
  const getPromotionCount = async () => {
    // console.log(date);
    const formattedDate = new Date(date).toLocaleDateString("en-CA");
    // console.log(formattedDate);

    try {
      const res = await axios.get(
        `https://mtnfunnybone.com/promotion-data/count?date=${formattedDate}`
      );
      console.log(res.data[0].count);
      setCount(res.data[0].count);
    } catch (err) {
      console.log(err);
    }
  };

  const getPromotionData = async () => {
    // console.log(date);
    const formattedDate1 = new Date(startDate).toLocaleDateString("en-CA");
    const formattedDate2 = new Date(endDate).toLocaleDateString("en-CA");
    // console.log(formattedDate);

    const body = {
      start_date: formattedDate1,
      end_date: formattedDate2,
    };

    try {
      const res = await axios.post(
        `https://mtnfunnybone.com/promotion-data`,
        body
      );
      console.log(res.data.promotion);
      setData(res.data.promotion);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getPromotionCount();
  }, [date]);

  useEffect(() => {
    getPromotionData();
  }, [startDate, endDate]);

  // Function to show the calendar popup on icon click
  

  return (
    <div className={classes.container}>
      <Navbar />
      <div className={classes.main}>
        <p className={classes.title}>
          PUBLISHER TRAFFIC
          {/* of {new Date(date).toLocaleDateString('en-CA')} */}
        </p>

        <div className={classes.inputs_dates}>
          <div className={classes.input_div}>
            {/* Assign ref to Calendar component */}
            <Calendar
              ref={countCalendarRef}
              value={date}
              maxDate={new Date()}
              onChange={(e) => setDate(e.value)}
              dateFormat="dd/mm/yy"
              className={classes.input}
              // This will also add a default calendar icon
            />

            {/* Custom icon to trigger calendar */}
            <i
              className="pi pi-calendar-clock"
              onClick={() => countCalendarRef.current.show()}
              style={{ cursor: "pointer", marginLeft: "10px" }}
            ></i>
          </div>

          <div className={classes.input_div}>{count}</div>
        </div>

        <p className={classes.title}>
          PROMOTION DATA
          {/* of {new Date(date).toLocaleDateString('en-CA')} */}
        </p>

        <div className={classes.inputs_dates}>
          <div className={classes.input_div}>
            {/* Assign ref to Calendar component */}
            <Calendar
              ref={startCalendarRef}
              value={startDate}
              maxDate={new Date()}
              onChange={(e) => setStartDate(e.value)}
              dateFormat="dd/mm/yy"
              className={classes.input}
              // This will also add a default calendar icon
            />

            {/* Custom icon to trigger calendar */}
            <i
              className="pi pi-calendar-clock"
              onClick={() => startCalendarRef.current.show()}
              style={{ cursor: "pointer", marginLeft: "10px" }}
            ></i>
          </div>
          <div className={classes.input_div}>
            {/* Assign ref to Calendar component */}
            <Calendar
              ref={endCalendarRef}
              value={endDate}
              maxDate={new Date()}
              onChange={(e) => setEndDate(e.value)}
              dateFormat="dd/mm/yy"
              className={classes.input}
              // This will also add a default calendar icon
            />

            {/* Custom icon to trigger calendar */}
            <i
              className="pi pi-calendar-clock"
              onClick={() => endCalendarRef.current.show()}
              style={{ cursor: "pointer", marginLeft: "10px" }}
            ></i>
          </div>
        </div>

        <DataTable
          value={data}
          showGridlines
          tableStyle={{ minWidth: "50rem" }}
          className="w-full custom-table rounded-md text-center"
        >
          <Column
            field="partner"
            header="Partner"
            alignHeader="center"
            headerClassName="bg-gray-300"
          ></Column>
          <Column
            field="servicename"
            header="serviceName"
            alignHeader="center"
            headerClassName="bg-gray-300"
          ></Column>
          <Column
            field="date_only"
            header="DATE"
            alignHeader="center"
            headerClassName="bg-gray-300 "
            body={(rowData) =>
              new Date(rowData.date_only).toLocaleDateString("en-GB")
            }
          />
          <Column
            field="total"
            header="Total"
            alignHeader="center"
            headerClassName="bg-gray-300"
          ></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default PromotionData;
